(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/javascripts/prescript.js');

'use strict';

svs.gamePackage = svs.gamePackage || {};
svs.gamePackage.redux = {};
svs.gamePackage.redux.middlewares = {};
svs.gamePackage.redux.selectors = {};
svs.gamePackage.redux.thunks = {};
svs.gamePackage.components = {};
svs.gamePackage.hooks = {};
svs.gamePackage.pay = {};
svs.gamePackage.logger = new svs.core.log.Logger('modules:game-package');

 })(window);